import React from 'react';
import Header from './Header';
import Footer from './Footer';
import InfoPageBody from './InfoPageBody';
import { INFO_PAGE_CONTENT } from './infoPageContent';
import './InfoPage.css';

const InfoPage = ({ pageKey }) => {
  const page = INFO_PAGE_CONTENT[pageKey];

  if (!page) {
    return null;
  }

  return (
    <div className="info-page-wrapper">
      <Header />
      <main className="info-page-main">
        <InfoPageBody page={page} />
      </main>
      <Footer />
    </div>
  );
};

export default InfoPage;
